<template>
  <div class="FamilyProfile">

    <h1 class="m-label" style="margin: 0">
      家庭基本情報
    </h1>

    <template v-if="family.id == edit_id.family_id">
      <form @submit.prevent="patchFamily(family)">
        <div class="m-box__inner">
          <table class="m-detail">
            <template v-if="!valid">
              <tr>
                <th>エラー</th>
                <td class="errors"><div>{{errors}}が入力されていません</div></td>
              </tr>
            </template>
            <tr>
              <th>会社名</th>
              <template v-if="family.company">
                <td>{{family.company.name}}</td>
              </template>
            </tr>
            <tr>
              <th>営業所</th>
              <td><multiselect v-model="watch.office_id" :options="offices" label="name" :searchable="false" :show-labels="false" placeholder="営業所"></multiselect></td>
            <tr>
              <th>初契約日</th>
              <td><div class="calc">{{contract_dateFirst}}</div></td>
            </tr>
            <tr>
              <th>最新契約日</th>
              <td><div class="calc">{{contract_dateLatest}}</div></td>
            </tr>
            <tr>
              <th>ID</th>
              <td><div class="calc">{{family.id}}</div></td>
            </tr>
            <tr>
              <th>名前</th>
              <td><input type="text" class="name_w" v-model="family.f_name" @keypress.self.prevent.13><input type="text" class="name_w" v-model="family.l_name" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th class="req">かな</th>
              <td><input type="text" required class="name_w" v-model="family.f_name_kana" @keypress.self.prevent.13><input type="text" required class="name_w" v-model="family.l_name_kana" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>続柄</th>
              <td><multiselect v-model="watch.relationship" :options="relationship" label="name" :searchable="false" :show-labels="false" placeholder="続柄"></multiselect></td>
            </tr>
            <tr>
              <th>郵便番号</th>
              <td><input type="text" v-model="family.zip" @keyup="getYubin" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th class="req">都道府県</th>
              <td><multiselect v-model="watch.pref" :options="prefs" label="name" :searchable="true" :show-labels="false" placeholder="都道府県"></multiselect></td>
            </tr>
            <tr>
              <th class="req">市区町村・番地</th>
              <td>
                <input type="text" required v-model="family.address1" @keypress.self.prevent.13>
              </td>
            </tr>
            <tr>
              <th>建物名・部屋番号</th>
              <td>
                <input type="text" v-model="family.address2" @keypress.self.prevent.13>
              </td>
            </tr>
            <tr>
              <th class="req">携帯TEL</th>
              <td><input type='text' required maxlength="11" minlength="10" v-model="family.tel1" placeholder="携帯TEL" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>固定TEL</th>
              <td><input type='text' maxlength="11" minlength="10" v-model="family.tel2" placeholder="固定TEL" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>FAX</th>
              <td><input type="text" v-model="family.fax" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>MAIL1</th>
              <td><input type="text" v-model="family.mail" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>MAIL2</th>
              <td><input type="text" v-model="family.mail2" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>指導種類</th>
              <td><multiselect v-model="watch.guidance_type" :options="guidance_type" label="name" :searchable="false" :show-labels="false" placeholder="指導種類"></multiselect></td>
            </tr>
            <tr>
              <th>家族構成</th>
              <td><input v-model="family.structure" placeholder="家族構成" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>件口</th>
              <td><multiselect v-model="watch.unit" :options="unit" label="name" :searchable="false" :show-labels="false" placeholder="件口"></multiselect></td>
            </tr>
            <tr>
              <th>勤め先連絡先</th>
              <td><input v-model="family.workplace_contact" placeholder="勤め先連絡先" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>優先連絡先</th>
              <td><multiselect v-model="watch.preferred_contact" :options="preferred_contact" label="name" :searchable="false" :show-labels="false" placeholder="優先連絡先"></multiselect></td>
            </tr>
            <tr>
              <th>連絡曜日時間帯</th>
              <td><input v-model="family.contact_timezone" placeholder="連絡曜日時間帯" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>退会日</th>
              <td><input type="text" maxlength="10" minlength="10" v-model="family.withdrawal_date" placeholder="退会日" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>備考1</th>
              <td><textarea v-model="family.note1"></textarea></td>
            </tr>
            <tr>
              <th>備考2</th>
              <td><textarea v-model="family.note2"></textarea></td>
            </tr>
          </table>
        </div>

        <div style="display: flex">
          <btn class="m-btn m-btn--default"><i class="fa fa-pencil-square-o"></i>更新</btn>
          <btn class="m-btn m-btn--default cancel" type="button" @click.native.prevent="cancelFamily(family)"><i class="fa fa-pencil-square-o"></i>キャンセル</btn>
        </div>

      </form>
    </template>

    <template v-if="family.id !== edit_id.family_id">
      <div class="m-box__inner">
        <table class="m-detail">
          <template v-if="!valid">
            <tr>
              <th>エラー</th>
              <td class="errors"><div>{{errors}}が入力されていません</div></td>
            </tr>
          </template>
          <tr>
            <th>会社名</th>
            <template v-if="family.company">
              <td>{{family.company.name}}</td>
            </template>
            <template v-else>
              <td></td>
            </template>
          </tr>
          <tr>
            <th>営業所</th>
            <template v-if="family.office_id">
              <td>{{office}}</td>
            </template>
            <template v-else>
              <td></td>
            </template>
          </tr>
          <tr>
            <th>初契約日</th>
            <td>{{contract_dateFirst}}</td>
          </tr>
          <tr>
            <th>最新契約日</th>
            <td>{{contract_dateLatest}}</td>
          </tr>
          <tr>
            <th>ID</th>
            <td>{{family.id}}</td>
          </tr>
          <tr>
            <th>名前</th>
            <td>{{family.f_name}} {{family.l_name}}</td>
          </tr>
          <tr>
            <th>かな</th>
            <td>{{family.f_name_kana}} {{family.l_name_kana}}</td>
          </tr>
          <tr>
            <th>続柄</th>
            <!-- <td>{{family.relationship}}</td> -->
            <td v-if="family.relationship === 0">未選択</td>
            <td v-if="family.relationship === 1">母</td>
            <td v-if="family.relationship === 2">父</td>
            <td v-if="family.relationship === 3">祖母</td>
            <td v-if="family.relationship === 4">祖父</td>
            <td v-if="family.relationship === 5">本人</td>
            <td v-if="family.relationship === 6">伯母</td>
            <td v-if="family.relationship === 7">伯父</td>
          </tr>
          <tr>
            <th>郵便番号</th>
            <td>{{family.zip}}</td>
          </tr>
          <tr>
            <th>都道府県</th>
            <template v-if="family.pref">
              <td>{{prefName}}</td>
            </template>
            <template v-else>
              <td></td>
            </template>
          </tr>
          <tr>
            <th>市区町村・番地</th>
            <td>{{family.address1}}</td>
          </tr>
          <tr>
            <th>建物名・部屋番号</th>
            <td>{{family.address2}}</td>
          </tr>
          <tr>
            <th>携帯TEL</th>
            <td>{{family.tel1}}</td>
          </tr>
          <tr>
            <th>固定TEL</th>
            <td>{{family.tel2}}</td>
          </tr>
          <tr>
            <th>FAX</th>
            <td>{{family.fax}}</td>
          </tr>
          <tr>
            <th>MAIL1</th>
            <td>{{family.mail}}</td>
          </tr>
          <tr>
            <th>MAIL2</th>
            <td>{{family.mail2}}</td>
          </tr>
          <tr>
            <th>指導種類</th>
            <td v-if="family.guidance_type === 0">未選択</td>
            <td v-if="family.guidance_type === 1">1人指導</td>
            <td v-if="family.guidance_type === 2">2人同時指導</td>
            <td v-if="family.guidance_type === 3">3人同時指導</td>
          </tr>
          <tr>
            <th>家族構成</th>
            <td>{{family.structure}}</td>
          </tr>
          <tr>
            <th>件口</th>
            <td v-if="family.unit === 0">未選択</td>
            <td v-if="family.unit === 1">1件口</td>
            <td v-if="family.unit === 2">2件口</td>
            <td v-if="family.unit === 3">3件口</td>
          </tr>
          <tr>
            <th>勤め先連絡先</th>
            <td>{{family.workplace_contact}}</td>
          </tr>
          <tr>
            <th>優先連絡先</th>
            <td v-if="family.preferred_contact === 0">未選択</td>
            <td v-if="family.preferred_contact === 1">自宅</td>
            <td v-if="family.preferred_contact === 2">携帯</td>
            <td v-if="family.preferred_contact === 3">勤務先</td>
            <td v-if="family.preferred_contact === 4">その他</td>
          </tr>
          <tr>
            <th>連絡曜日時間帯</th>
            <td>{{family.contact_timezone}}</td>
          </tr>
          <tr>
            <th>退会日</th>
            <td>{{family.withdrawal_date}}</td>
          </tr>
          <tr>
            <th>備考1</th>
            <td style="white-space: pre-wrap">{{family.note1}}</td>
          </tr>
          <tr>
            <th>備考2</th>
            <td style="white-space: pre-wrap">{{family.note2}}</td>
          </tr>
        </table>
      </div>
      <btn @click.native="edit(family)"><i class="fa fa-pencil-square-o"></i>編集</btn>
    </template>
  </div>
</template>

<script>
let jsonp = require('jsonp')
export default {
  props: {
    family: Object,
    edit_id: Object
  },
  data () {
    return {
      geometry: '',
      watch: {
        office_id: '',
        relationship: '',
        pref: '',
        guidance_type: '',
        unit: '',
        preferred_contact: ''
      },
      relationship: [
        { name: '未選択', value: 0 },
        { name: '母', value: 1 },
        { name: '父', value: 2 },
        { name: '祖母', value: 3 },
        { name: '祖父', value: 4 },
        { name: '本人', value: 5 },
        { name: '伯母', value: 6 },
        { name: '伯父', value: 7 }
      ],
      guidance_type: [
        { name: '未選択', value: 0 },
        { name: '1人指導', value: 1 },
        { name: '2人同時指導', value: 2 },
        { name: '3人同時指導', value: 3 }
      ],
      unit: [
        { name: '未選択', value: 0 },
        { name: '1件口', value: 1 },
        { name: '2件口', value: 2 },
        { name: '3件口', value: 3 }
      ],
      preferred_contact: [
        { name: '未選択', value: 0 },
        { name: '自宅', value: 1 },
        { name: '携帯', value: 2 },
        { name: '勤務先', value: 3 },
        { name: 'その他', value: 4 }
      ]
    }
  },
  computed: {
    companies () {
      return this.$store.getters.companies
    },

    offices () {
      return this.$store.getters.offices
    },

    office () {
      return this.offices.filter(office => {
        return office.id === this.family.office_id
      })[0].name
    },

    prefs () {
      return this.$store.getters.prefs
    },

    prefName () {
      return this.prefs.filter(pref => {
        return pref.id === this.family.pref
      })[0].name
    },

    // validation
    f_name_kanaErrors: function () {
      return this.family.f_name_kana ? [] : ['せい']
    },
    l_name_kanaErrors: function () {
      return this.family.l_name_kana ? [] : ['めい']
    },
    prefErrors: function () {
      return this.family.pref ? [] : ['都道府県']
    },
    address1Errors: function () {
      return this.family.address1 ? [] : ['住所(市区町村・番地)']
    },
    tel1Errors: function () {
      return this.family.tel1 ? [] : ['携帯TEL']
    },
    withdrawal_dateErrors: function () {
      return this.family.withdrawal_date ? [] : ['退会日']
    },

    errors: function () {
      let errors = [].concat(
        this.f_name_kanaErrors,
        this.l_name_kanaErrors,
        this.prefErrors,
        this.address1Errors,
        this.tel1Errors,
        this.withdrawal_dateErrors
      )
      let errorsJoin = errors.join('・')
      return errorsJoin
    },
    valid: function () {
      return !this.errors
    },

    contract_dateLatest: function () {
      let self = this
      if (!self.family.students) {
        return
      }
      if (!self.family.students.length > 0) {
        return
      }
      let contract_dates = []
      let contract_dateList = self.family.students.map(function (student) {
        return student.agreements.map(function (agreement) {
          return agreement.contract_date
        })
      })
      contract_dateList.forEach(function (student) {
        student.forEach(function (contract_date) {
          contract_dates.push(contract_date)
        })
      })

      return contract_dates.sort().reverse()[0]
    },

    contract_dateFirst: function () {
      let self = this
      if (!self.family.students) {
        return
      }
      if (!self.family.students.length > 0) {
        return
      }
      let contract_dates = []
      let contract_dateList = self.family.students.map(function (student) {
        return student.agreements.map(function (agreement) {
          return agreement.contract_date
        })
      })
      contract_dateList.forEach(function (student) {
        student.forEach(function (contract_date) {
          contract_dates.push(contract_date)
        })
      })

      return contract_dates.sort()[0]
    }
  },
  watch: {
    'watch.office_id': function (now, old) {
      // console.log(now)
      if (now) {
        this.family.office_id = now.id
      }
    },

    'watch.relationship': function (now, old) {
      // console.log(now)
      if (now) {
        this.family.relationship = now.value
      }
    },

    'watch.pref': function (now, old) {
      // console.log(now)
      if (now) {
        this.family.pref = now.id
        this.geometry = now.name
      }
    },

    'watch.guidance_type': function (now, old) {
      // console.log(now)
      if (now) {
        this.family.guidance_type = now.value
      }
    },

    'watch.unit': function (now, old) {
      // console.log(now)
      if (now) {
        this.family.unit = now.value
      }
    },

    'watch.preferred_contact': function (now, old) {
      // console.log(now)
      if (now) {
        this.family.preferred_contact = now.value
      }
    }
  },
  methods: {
    edit: function (family) {
      // console.log(family.company_id)
      // console.log(this.companies)
      // console.log(this.edit_id.family_id)
      this.watch.office_id = this.offices.filter((office) => {
        return office.id === this.family.office_id
      })[0]
      this.watch.relationship = this.relationship[this.family.relationship]
      this.watch.pref = this.prefs.filter((pref) => {
        return pref.id === this.family.pref
      })[0]
      this.watch.guidance_type = this.guidance_type[this.family.guidance_type]
      this.watch.unit = this.unit[this.family.unit]
      this.watch.preferred_contact = this.preferred_contact[this.family.preferred_contact]
      this.edit_id.family_id = family.id
    },

    cancelFamily: function () {
      // console.log('cancel')
      this.$store.dispatch('cancelFamily', {
        edit_id: this.edit_id
      })
    },

    patchFamily: function (family) {
      this.$store.dispatch('patchFamily', {
        this: this,
        family: family,
        geometry: this.geometry,
        edit_id: this.edit_id
      })
    },

    getYubin: function (e) {
      let that = this
      // console.log(e)
      const value = e.target.value
      if (value.length > 5 && that.family.address1 === '') {
        jsonp('http://zipcloud.ibsnet.co.jp/api/search?zipcode=' + value, null, function (err, data) {
          if (err) {
            // error
            console.error(err.message)
          } else {
            // success
            // console.log(data)
            if (data.results[0].address1 === '北海道') {
              that.watch.pref = { name: '1. 北海道', value: 1 }
            } else if (data.results[0].address1 === '青森県') {
              that.watch.pref = { name: '2. 青森県', value: 2 }
            } else if (data.results[0].address1 === '秋田県') {
              that.watch.pref = { name: '3. 秋田県', value: 3 }
            } else if (data.results[0].address1 === '岩手県') {
              that.watch.pref = { name: '4. 岩手県', value: 4 }
            } else if (data.results[0].address1 === '山形県') {
              that.watch.pref = { name: '5. 山形県', value: 5 }
            } else if (data.results[0].address1 === '宮城県') {
              that.watch.pref = { name: '6. 宮城県', value: 6 }
            } else if (data.results[0].address1 === '福島県') {
              that.watch.pref = { name: '7. 福島県', value: 7 }
            } else if (data.results[0].address1 === '栃木県') {
              that.watch.pref = { name: '8. 栃木県', value: 8 }
            } else if (data.results[0].address1 === '山梨県') {
              that.watch.pref = { name: '9. 山梨県', value: 9 }
            } else if (data.results[0].address1 === '群馬県') {
              that.watch.pref = { name: '10. 群馬県', value: 10 }
            } else if (data.results[0].address1 === '茨城県') {
              that.watch.pref = { name: '11. 茨城県', value: 11 }
            } else if (data.results[0].address1 === '千葉県') {
              that.watch.pref = { name: '12. 千葉県', value: 12 }
            } else if (data.results[0].address1 === '埼玉県') {
              that.watch.pref = { name: '13. 埼玉県', value: 13 }
            } else if (data.results[0].address1 === '東京都') {
              that.watch.pref = { name: '14. 東京都', value: 14 }
            } else if (data.results[0].address1 === '神奈川県') {
              that.watch.pref = { name: '15. 神奈川県', value: 15 }
            } else if (data.results[0].address1 === '静岡県') {
              that.watch.pref = { name: '16. 静岡県', value: 16 }
            } else if (data.results[0].address1 === '長野県') {
              that.watch.pref = { name: '17. 長野県', value: 17 }
            } else if (data.results[0].address1 === '愛知県') {
              that.watch.pref = { name: '18. 愛知県', value: 18 }
            } else if (data.results[0].address1 === '岐阜県') {
              that.watch.pref = { name: '19. 岐阜県', value: 19 }
            } else if (data.results[0].address1 === '新潟県') {
              that.watch.pref = { name: '20. 新潟県', value: 20 }
            } else if (data.results[0].address1 === '富山県') {
              that.watch.pref = { name: '21. 富山県', value: 21 }
            } else if (data.results[0].address1 === '石川県') {
              that.watch.pref = { name: '22. 石川県', value: 22 }
            } else if (data.results[0].address1 === '福井県') {
              that.watch.pref = { name: '23. 福井県', value: 23 }
            } else if (data.results[0].address1 === '滋賀県') {
              that.watch.pref = { name: '24. 滋賀県', value: 24 }
            } else if (data.results[0].address1 === '京都府') {
              that.watch.pref = { name: '25. 京都府', value: 25 }
            } else if (data.results[0].address1 === '三重県') {
              that.watch.pref = { name: '26. 三重県', value: 26 }
            } else if (data.results[0].address1 === '和歌山県') {
              that.watch.pref = { name: '27. 和歌山県', value: 27 }
            } else if (data.results[0].address1 === '奈良県') {
              that.watch.pref = { name: '28. 奈良県', value: 28 }
            } else if (data.results[0].address1 === '大阪府') {
              that.watch.pref = { name: '29. 大阪府', value: 29 }
            } else if (data.results[0].address1 === '兵庫県') {
              that.watch.pref = { name: '30. 兵庫県', value: 30 }
            } else if (data.results[0].address1 === '鳥取県') {
              that.watch.pref = { name: '31. 鳥取県', value: 31 }
            } else if (data.results[0].address1 === '島根県') {
              that.watch.pref = { name: '32. 島根県', value: 32 }
            } else if (data.results[0].address1 === '岡山県') {
              that.watch.pref = { name: '33. 岡山県', value: 33 }
            } else if (data.results[0].address1 === '広島県') {
              that.watch.pref = { name: '34. 広島県', value: 34 }
            } else if (data.results[0].address1 === '山口県') {
              that.watch.pref = { name: '35. 山口県', value: 35 }
            } else if (data.results[0].address1 === '高知県') {
              that.watch.pref = { name: '36. 高知県', value: 36 }
            } else if (data.results[0].address1 === '徳島県') {
              that.watch.pref = { name: '37. 徳島県', value: 37 }
            } else if (data.results[0].address1 === '香川県') {
              that.watch.pref = { name: '38. 香川県', value: 38 }
            } else if (data.results[0].address1 === '愛媛県') {
              that.watch.pref = { name: '39. 愛媛県', value: 39 }
            } else if (data.results[0].address1 === '福岡県') {
              that.watch.pref = { name: '40. 福岡県', value: 40 }
            } else if (data.results[0].address1 === '佐賀県') {
              that.watch.pref = { name: '41. 佐賀県', value: 41 }
            } else if (data.results[0].address1 === '長崎県') {
              that.watch.pref = { name: '42. 長崎県', value: 42 }
            } else if (data.results[0].address1 === '熊本県') {
              that.watch.pref = { name: '43. 熊本県', value: 43 }
            } else if (data.results[0].address1 === '宮崎県') {
              that.watch.pref = { name: '44. 宮崎県', value: 44 }
            } else if (data.results[0].address1 === '大分県') {
              that.watch.pref = { name: '45. 大分県', value: 45 }
            } else if (data.results[0].address1 === '鹿児島県') {
              that.watch.pref = { name: '46. 鹿児島県', value: 46 }
            } else if (data.results[0].address1 === '沖縄県') {
              that.watch.pref = { name: '47. 沖縄県', value: 47 }
            }
            // that.family.pref = data.results[0].address1
            that.family.address1 = data.results[0].address2 + data.results[0].address3
          }
        })
      }
    }
  }
}
</script>

<style lang='scss'>
.errors {
  color: red;
  font-size: .85rem;
}
.req {
  background: #dffbef;
}
.m-detail {
  border-collapse: collapse;
  font-size: 14px;
  width: 100%;
  th {
    text-align: left;
    width: 9rem;
  }
  th,td {
    padding: .5em;
    border-bottom: 1px solid #e6e4e4;
    word-break: break-word;
    /*border-bottom: 1px solid color(var(--color-border) blackness(+20%));*/
  }
}
</style>
<style lang='scss' scoped>
.fa-pencil-square-o {
  margin-right: 5px;
  font-weight: bold;
}
td {
  padding: 0 !important;
  height: 34px;
  input {
    width: 100%;
    font-size: 14px;
    border: none;
    height: 34px;
    &.name_w {
      width: 50%;
    }
    &:focus {
      color: #337bc4;
      font-weight: bold;
      border: solid 3px;
      outline: 0;
    }
  }
  textarea {
    width: 100%;
    font-size: 14px;
    border: none;
    height: 100px;
    &:focus {
      color: #337bc4;
      font-weight: bold;
      border: solid 3px;
      outline: 0;
    }
  }
  .calc {
    padding: 8px;
  }
}
.cancel {
  margin-top: 0 !important;
}
.fa-pencil {
  margin-right: 5px;
  font-weight: bold;
}
.m-box__inner {
  height: calc(100vh - 262px);
  overflow-y: scroll;
  border: 1px solid #eee;
}
</style>
<style lang="scss">
.FamilyProfile {
  .multiselect {
    min-height: 26px;
  }
  .multiselect__tags {
    border: 0;
    min-height: 26px;
    padding: 0px 40px 0 2px;
  }
  .multiselect__input {
    margin-bottom: 0;
    height: 26px;
    font-size: 14px;
  }
  .multiselect__select {
    height: 26px;
  }
  .multiselect__single {
    margin-top: 3px;
    margin-bottom: 3px;
  }
  // .multiselect--active {
  .multiselect__content-wrapper {
    z-index: 10;
  }
}
</style>



// WEBPACK FOOTER //
// FamilyProfile.vue?8882f21a